// const socketProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
// const port = ":3000";
// const echoSocketUrl =
//   socketProtocol + "//" + window.location.hostname + port + "/";
const socket = new WebSocket(process.env.VUE_APP_WS);
export default socket;
